import {useEffect, createRef} from 'react';
import {useLocation} from 'react-router-dom';
import Main from './main';
import Gifts from './gifts';
import MainPrize from './main_prize';
import Tasks from './tasks';
import How from './how';
import Footer from './footer';
import Modals from './modals';

export default () => {
    const location = useLocation(),
          block = createRef();

    const resizeHandler = () => {
        let koef = document.body.offsetWidth / 430;
        const margin = ((koef - 1) / 2) * 2809;

        if(block.current && koef > 1) {
            block.current.style.transform = `scale(${koef})`;
            block.current.style.marginTop = `${margin}px`;
        } else {
            block.current.style.transform = `scale(1)`;
            block.current.style.marginTop = `0px`;
        }
    }

    useEffect(() => {
        resizeHandler();
        window.addEventListener('resize', resizeHandler);
        return () => window.removeEventListener('resize', resizeHandler);
    }, [location]);

    return (
        <div className="h-page">
            <Modals />
            <div className="h-block" ref={block}>
                <Main />
                <Gifts />
                <MainPrize />
                <Tasks />
                <How />
                <Footer />
            </div>
        </div> 
    )
}